import React, { useState, useEffect } from 'react';
import PeopleIcon from '@mui/icons-material/People';
import RefreshIcon from '@mui/icons-material/Refresh';
import CentralCalls from '../../centralCalls';
const TeamDropdown = ({ onAddCrew, currentCrews }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [crews,setCrews] = useState([]);

  const fetchCrews = async () => {
    try {
      const result = await CentralCalls.callStoredProcedureWithParams('sp_getCrewList', { is_primary: 0, inactive: 0 });
      // Create a Set of team_oids from currentCrews for fast lookup
      const excludedTeamOids = new Set(currentCrews.map(crew => crew.team_oid));
      // Filter out crews whose team_oid is in excludedTeamOids
      const filteredCrews = result.filter(crew => !excludedTeamOids.has(crew.team_oid));
      // Sort filtered crews by team_name
      const sortedCrews = [...filteredCrews].sort((a, b) =>
        (a.team_name || '').localeCompare(b.team_name || '')
      );
      setCrews(sortedCrews);
    } catch (error) {
      console.error('Failed to fetch crews:', error);
    }
  };

  useEffect(() => {
    fetchCrews();
  }, []);
    const crewSelected = (crew) => {
      onAddCrew(crew);
      setCrews(prev => prev.filter(c => c.team_oid !== crew.team_oid));
      setIsHovered(false);
     }
  return (
    <div
      style={{ position: 'relative', display: 'inline-block', marginLeft: '10px' }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <div className="icon-header">
        <PeopleIcon fontSize="large" />
      </div>

      {isHovered && (
        <div
          style={{
            position: 'absolute',
            top: '100%',
            left: 0,
            background: 'white',
            border: '1px solid #ccc',
            borderRadius: '4px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
            zIndex: 1000,
            padding: '8px',
            maxHeight: '150px',
            overflowY: 'auto',
            width: '200px'
          }}
        >
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px', paddingBottom: '4px', borderBottom: '1px solid #eee' }}>
            <span style={{ fontWeight: 'bold' }}>Available Crews</span>
            <RefreshIcon 
              style={{ cursor: 'pointer', fontSize: '18px', color: '#666' }} 
              onClick={(e) => {
                e.stopPropagation();
                fetchCrews();
              }} 
              titleAccess="Refresh crews list"
            />
          </div>
          {crews?.map((crew, i) => (
            <div
              key={i}
              style={{
                padding: '4px 8px',
                cursor: 'pointer',
                whiteSpace: 'nowrap',
              }}
              onClick={() => crewSelected(crew)} 
            >
              {crew.team_name}
            </div>
          ))}
          {crews.length === 0 && (
            <div style={{ padding: '4px 8px', color: '#666', fontStyle: 'italic' }}>
              No crews available
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default TeamDropdown;
